import { Component } from '@angular/core';
import BaseIndexPageConfig from '../../../components/pages/base-index-page/base-index-page.config';
import { DataTableColumnActions } from '../../../components/widgets/data-table/columns/data-table-column-actions/data-table-column-actions.config';
import { DataTableColumnText } from '../../../components/widgets/data-table/columns/data-table-column-text/data-table-column-text.config';
import ApiOptionsConfig from '../../../services/api/api-options.config';
import { ProposalsService } from '../../../services/api/proposals.service';
import { RouteService } from '../../../services/route.service';
import { BaseIndexPageComponent } from '../../../components/pages/base-index-page/base-index-page.component';
import { CommonService } from 'src/app/services/common.service';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-proposals-index-page',
  imports: [BaseIndexPageComponent],
  templateUrl: './proposals-index-page.component.html',
  styleUrl: './proposals-index-page.component.scss'
})
export class ProposalsIndexPageComponent {
  list: any[] = [];
  baseIndexPageConfig: BaseIndexPageConfig;

  private readonly nonEditableStatuses: string[] = [
    'PENDING_CLIENT',
    'ACCEPTED',
    'NOT_ACCEPTED'
  ];

  constructor(
    protected proposalsService: ProposalsService,
    private routeService: RouteService,
    protected commonService: CommonService
  ) {
    this.baseIndexPageConfig = {
      pageTitle: 'Proposals',
      cardTitle: 'Manage Proposals',
      dataTable: {
        data: [],
        searchModel: {
          userId: null,
          firstName: null,
          lastName: null,
        },
        topInputFilters: [
          {
            label: 'Date From',
            attribute: 'proposalTimeStart',
            type: 'date'
          },
          {
            label: 'Date To',
            attribute: 'proposalTimeEnd',
            type: 'date'
          }
        ],
        pagination: null,
        inEvidence: (proposal: any) => proposal.isChangeOfScope === true,
        columns: [
          new DataTableColumnText({
            attribute: 'code',
            header: 'Code',
            filter: 'text',
            value: (proposal: any) => {
              return proposal.code;
            },
            note: (proposal: any) => this.changeOfScopeNote(proposal)
          }),
          new DataTableColumnText({
            attribute: 'proposalTime',
            header: 'Date',
            filter: 'text',
            value: (proposal: any) => {
              return this.commonService.formatDateOnly(new Date(proposal.proposalTime));
            }
          }),
          new DataTableColumnText({
            attribute: 'brandName',
            header: 'Brand Name',
            filter: 'text',
            value: (proposal: any) => {
              return proposal.customerBrand;
            }
          }),
          new DataTableColumnText({
            attribute: 'companyName',
            header: 'Company Name',
            filter: 'text',
            value: (proposal: any) => {
              return proposal.customerCompanyName;
            }
          }),
          new DataTableColumnText({
            attribute: 'clientName',
            header: 'Client Name',
            filter: 'text',
            value: (proposal: any) => {
              return proposal.customerFullName;
            }
          }),
          new DataTableColumnText({
            attribute: 'cos',
            header: 'Cos',
            filter: 'select',
            filterOptionsSource: 'boolean',
            width: '80px',
            value: (proposal: any) => {
              return proposal.isChangeOfScope ? 'Yes' : 'No';
            }
          }),
          new DataTableColumnText({
            attribute: 'summary',
            header: 'Summary',
            filter: 'text',
            value: (proposal: any) => {
              return proposal.summary;
            }
          }),
          new DataTableColumnText({
            attribute: 'sales',
            header: 'Sales',
            filter: 'text',
            value: (proposal: any) => {
              return proposal.sales;
            }
          }),
          new DataTableColumnText({
            attribute: 'status',
            header: 'Status',
            filter: 'select',
            value: (proposal: any) => {
              return proposal.status;
            }
          }),
          new DataTableColumnActions({
            header: 'Actions',
            attribute: 'actions',
            style: { width: '50px' },
            buttons: [
              {
                icon: 'fa-eye',
                tooltip: 'View proposal details',
                onClick: (proposal: any) => {
                  this.routeService.proposalsDetail(proposal.proposalId);
                },
                hidden: false
              },
              {
                icon: 'fa-edit',
                tooltip: 'Edit proposal',
                onClick: (proposal: any) => {
                  this.routeService.proposalsUpdate(proposal.proposalId);
                },
                hidden: (proposal: any) => this.isNonEditableProposal(proposal)
              },
              {
                icon: 'fa-trash',
                tooltip: 'Delete proposal',
                onClick: (proposal: any) => {
                  // this.routeService.userUpdate(proposal.userId);
                },
                hidden: false,
                isDelete: true
              }
            ]
          })
        ]
      },
      apiListService: (options: ApiOptionsConfig) => this.proposalsService.list(options),
      responseListModelName: 'proposals',
      exportExcelService: (params: HttpParams) => this.proposalsService.exportExcel(params),
    }

  }

  private changeOfScopeNote(proposal: any): string | null {
    return !proposal?.isChangeOfScope && proposal?.hasChangeOfScope
      ? 'Has change of scope'
      : null;
  }

  private isNonEditableProposal(proposal: any): boolean {
    return this.nonEditableStatuses.includes(proposal?.status);
  }
}
